let map: google.maps.Map;

export class MapComponent {

    public initMap(): void {

        var latitude = $("#latitude").val() as string;
        var longitude = $("#longitude").val() as string;

        if (Boolean(latitude) && Boolean(longitude)) {
            map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
                center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
                zoom: 8,
            });
        }
        var location = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
        this.addMarker(location, true);
    }

    public addMarker(location: google.maps.LatLngLiteral, centerToLocation: boolean): void {
        var markers = [];
        const marker = new google.maps.Marker({
            position: location,
            map: map,
            draggable: false
        });

        markers.push(marker);

        if (centerToLocation) {
            if (map !== null && map !== undefined) {
                map.setCenter(location);
            }
        }
    }
}